import createSvgIcon from '../Utils/CreateSvgIcon';

export const Export = createSvgIcon(
  <path d="M12 3L12.7071 2.29289L12 1.58579L11.2929 2.29289L12 3ZM11 14V15H13V14H11ZM7.70711 7.29289L12.7071 2.29289L11.2929 3.70711L6.29289 8.70711L7.70711 7.29289ZM11.2929 2.29289L16.2929 7.29289L17.7071 5.87868L12.7071 0.87868L11.2929 2.29289ZM11 3V14H13V3H11ZM4 12V20H20V12H22V22H2V12H4Z" />,
  'Export',
);
